import { ECalculateActionType } from '../../actions/calculate/types';
import { EFieldsStateActionTypes } from '../../actions/fieldsState';
import { ECalculateStatus, TCalculateState } from '../../types/calculate';
import { TReduxActions } from '../../types/redux';

const defaultState: TCalculateState = {
  status: ECalculateStatus.Initial,
  result: null,
  errorMessage: '',
};

export function calculateReducer(state: TCalculateState = defaultState, action: TReduxActions): TCalculateState {
  switch (action.type) {
    case ECalculateActionType.Succeed:
      return {
        ...state,
        status: ECalculateStatus.Succeed,
        result: action.payload,
        errorMessage: '',
      };
    case ECalculateActionType.Failed:
      return {
        ...state,
        status: ECalculateStatus.Failed,
        result: null,
        errorMessage: action.payload,
      };
    case ECalculateActionType.Loading:
      return {
        ...state,
        status: ECalculateStatus.Loading,
        result: null,
        errorMessage: '',
      };
    case EFieldsStateActionTypes.SetFieldsState:
      return {
        ...state,
        ...defaultState,
      };
  }

  return state;
}
